import React from 'react';
import '../Utilities/reset.css';
import './Link3.css';

function Link3(props) {
    return (
        <div className="home-container3">
            <section className="home-section3">
                Hello from Link3
            </section>
        </div>
    );
}

export default Link3;